import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

/**
 * Komponent SVG dla obszaru A - sedan widok prawy
 */
export const AreaA_Sedan_Right: React.FC<AreaSVGProps> = ({
  fill = '#73C69B',
  stroke = '#73C69B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="101"
      height="158"
      viewBox="0 0 101 158"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_a_sedan_right"
          x="0"
          y="0"
          width="101"
          height="158"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>

      <g filter="url(#filter_area_a_sedan_right)">
        <path
          d="M24.0616 7.7793C21.9134 15.1981 19.7467 23.6538 17.6232 33.1475C15.1177 44.3525 12.1963 59.8077 9.34387 74.9023L9.33313 74.9639C9.10772 76.1567 8.88259 77.3475 8.65833 78.5332C5.87753 93.2356 3.18159 107.328 1.08215 116.051L2.81555 118.362C3.81293 116.829 4.84612 115.242 5.90442 113.621L5.90735 113.617L6.36731 112.913C7.60981 111.01 9.98812 110.197 12.1359 110.939C14.2832 111.682 15.6503 113.79 15.4523 116.054C14.8026 123.472 13.9794 134.553 12.9952 147.796L12.9943 147.8C12.8399 149.877 12.6828 152.008 12.5206 154.186C17.7523 152.487 24.0963 151.532 30.9943 151.078C40.7133 150.438 52.1075 150.759 64.2072 151.748C79.4502 152.995 89.2897 154.314 98.7072 155.875C98.8397 149.512 98.9773 143.342 99.1095 137.446V137.444L99.4044 124.043C84.6298 123.857 74.4589 122.569 59.5841 115.4C39.997 105.965 25.9978 85.0753 26.3507 61.2773C26.4814 52.4955 28.0047 45.342 30.8468 38.3584C30.6753 37.9845 30.5094 37.624 30.3488 37.2754L30.3468 37.2695L30.3448 37.2666L30.3458 37.2656C30.122 36.78 29.9071 36.3169 29.7052 35.874C29.2052 34.7774 28.6145 33.4715 28.34 32.5117L28.338 32.5039L28.339 32.5029C27.4567 29.4044 26.7145 26.5206 26.1105 23.792C24.7974 17.8597 24.1513 12.7218 24.0616 7.7793Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
